import React from "react";
import "./Spinner.css"; // Import spinner styles
const Spinner = () => (
  <div className="spinner-container">
    <div className="spinner"></div>
  </div>
);
export default Spinner;
